/* eslint-disable no-console */
const prefix = '[ATM]';

export function trackAsyncPV(adobeTagManager) {
  if (adobeTagManager) {
    console.log(`${prefix} track ${window.location.pathname + window.location.search}`);
  } else {
    console.log(`${prefix} does not have ADOBE TAG MANAGER`);
  }
}
